import ResetPasswordSuccessPage from './reset-password-success-page';

export default ResetPasswordSuccessPage;
